import { Pipe, PipeTransform } from '@angular/core';
import {
  ACTIONED,
  COMMENTED,
  CREATED,
  FILE_ADDED,
  FILE_SAVED,
  FORWARDED_TO_EMAIL,
  HEARTED,
  PUBLIC_SHARED,
  SHARED,
  UPDATED,
  VIEWED,
} from '@careapp-group/core';

@Pipe({
  name: 'actionicon',
  standalone: false,
})
export class ActionIconPipe implements PipeTransform {
  public transform(type) {
    switch (type) {
      case FILE_ADDED:
        return 'ca-insert_drive_file';
      case UPDATED:
        return 'ca-mode_edit';
      case CREATED:
        return 'ca-plus';
      case VIEWED:
        return 'ca-eye';
      case ACTIONED:
        return 'ca-done_all';
      case SHARED:
        return 'ca-share';
      case HEARTED:
        return 'ca-heart';
      case COMMENTED:
        return 'ca-comment';
      case FILE_SAVED:
        return 'ca-download';
      case PUBLIC_SHARED:
        return 'grid_view_outline';
      case FORWARDED_TO_EMAIL:
        return 'ca-share';
      default:
        return type;
    }
  }
}
